<template>
  <div>
    <div class="layout-config">
      <div class="layout-config-content-wrapper">
        <a :class="['layout-config-button', 'layout-config-button-right']" :style="{ top: '16%' }"
          @click="emit('show-sidebar')">
          <i class="pi pi-book" v-tooltip="'Отчёты'"></i>
        </a>
      </div>
    </div>
    <Sidebar v-model:visible="activeSidebar" @hide="onHideSidebar()" class="menu-report" position="right">
      <div class="text-center font-bold" style="font-size: 17px">Отчёты</div>
      <hr />
      <ScrollPanel>
        <CustomDataTable :loading="loading" :data="menuReport" :columns="columns" v-model:selectedRow="selectedReport"
          @update:selectedRow="showReport">
          <template #header>
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
              </span>
              <InputText placeholder="Поиск..." v-model="search" class="p-inputtext-sm" />
            </div>
          </template>
        </CustomDataTable>
      </ScrollPanel>
    </Sidebar>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeMount, computed, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import KeyController from 'keycon';

const props = defineProps({
  active: Boolean,
});

const emit = defineEmits(['show-sidebar', 'hide-sidebar']);

const store = useStore();
const router = useRouter();

const search = ref('');
const reportDialog = ref(false);
const selectedReport = ref(null);
const activeSidebar = ref(false);
const loading = ref(true);
const menuReport = ref(null);
const menuReportTemp = ref(null);
const inputEvent = ref(false);
const reportService = ref(null);

const columns = [
  { field: 'report_id' },
  {
    field: 'report_struct_name',
    dataType: 'image-text',
    imageField: 'icon_index',
  },
];

onBeforeMount(() => {
  const config = store.getters.config;
  if (config('layouts')['appMenuReport']) {
    const { serviceName, entityName, entitySpec } = config('appMenuReport');
    reportService.value = store.getters.nameToService(
      serviceName,
      null,
      null,
      entityName,
      entitySpec
    );
    reportService.value.getData().then((data) => {
      menuReport.value = data;
      menuReportTemp.value = data.map(item => item);
      loading.value = false;
    });
  }
});

onMounted(() => {
  window.Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile(
    'localization/ru.xml'
  );
  window.StiOptions.WebServer.url = store.getters.server('ADAPTER');
  //window.StiOptions.WebServer.encryptData = false;
  KeyController.global
    .keydown('ctrl', () => {
      inputEvent.value = true;
    })
    .keyup('ctrl', () => {
      inputEvent.value = false;
    });
});

const showReport = () => {
  if (inputEvent.value) {
    const route = router.resolve({
      name: 'report-viewer',
      params: { id: selectedReport.value.report_id },
    });
    window.open(route.href, '_blank');
  } else {
    openReport();
  }
}

const openReport = () => {
  if (selectedReport.value.report_id) {
    router.push({
      name: 'report-viewer',
      params: { id: selectedReport.value.report_id },
    });
  }
}

const onHideSidebar = () => {
  search.value = '';
  emit('hide-sidebar');
}

const onNewReport = () => {
  selectedReport.value = {};
  reportDialog.value = true;
}

watch(search, () => {
  if (!menuReportTemp.value) return;
  menuReport.value = menuReportTemp.value
    .map(item => item)
    .filter(item =>
      item.report_struct_name.toLowerCase().includes(search.value.toLowerCase())
    );
});

watch(
  () => props.active,
  (val) => {
    activeSidebar.value = val;
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.menu-report {
  width: 22rem;
}

.p-sidebar {
  padding: 0.3rem;
}

@media screen and (max-width: 960px) {
  .menu-report {
    width: 26%
  }
}

@media screen and (max-width: 640px) {
  .menu-report {
    width: 35%
  }
}

@media screen and (max-width: 460px) {
  .menu-report {
    width: 50%
  }
}
</style>